import React, { Component } from "react"
import PaymentHistoryTableRow from "./payment_history_table_row"

const BILLING_OVERVIEW_PAYMENT_HISTORY = "Payment History"
const BILLING_OVERVIEW_PAYMENT_USD = "Amounts shown in USD"
const paymentHistoryTableHeaderItems = [
    "Invoice #",
    "Date",
    "Payment Method",
    "Amount",
    "Receipt",
]

class BillingSettingsPaymentHistory extends Component {
    constructor(props) {
        super(props)
    }

    renderJustifyLastItem = (i, lastHeaderItem) =>
        i === lastHeaderItem ? "justify-last-item" : ""

    renderTableHeaderItems = (headerItems = []) => {
        const lastHeaderItem = headerItems.length - 1
        return (
            <div className="billing-overview-table-row">
                {headerItems.filter(item => item !== "Receipt").map((item, i) => (
                    <p
                        className={`table-header-item ${this.renderJustifyLastItem(
                            i,
                            lastHeaderItem,
                        )}`}
                        key={i}
                    >
                        {item}
                    </p>
                ))}
            </div>
        )
    }

    renderPaymentHistory = payments => {
        if (payments === undefined) {
            return null
        }

        if (Array.isArray(payments)) {
            return payments.map((payment, i) => (
                <PaymentHistoryTableRow
                    createdAt={payment.createdAt}
                    paymentMethod={payment.paymentMethod}
                    amount={payment.amount}
                    invoiceNumber={payment.stripeInvoiceNumber}
                    key={i}
                />
            ))
        } else {
            return (
                <PaymentHistoryTableRow
                    createdAt={payments.createdAt}
                    paymentMethod={payments.paymentMethod}
                    amount={payments.amount}
                    invoiceNumber={payments.stripeInvoiceNumber}
                />
            )
        }
    }

    render() {
        const {
            customer: { payments },
        } = this.props

        return (
            <div>
                <p>{BILLING_OVERVIEW_PAYMENT_HISTORY}</p>
                <div className="billing-overview-table">
                    {this.renderTableHeaderItems(
                        paymentHistoryTableHeaderItems,
                    )}
                    {this.renderPaymentHistory(payments)}
                </div>
                <p className="billing-overview-payment-usd">
                    {BILLING_OVERVIEW_PAYMENT_USD}
                </p>
            </div>
        )
    }
}

export default BillingSettingsPaymentHistory



// WEBPACK FOOTER //
// ./src/components/billing_settings_payment_history.jsx